import { Link } from 'react-router-dom';
import { Card, Title, Text, Flex } from '@tremor/react';
import { useUsageMetrics } from '../hooks/useStats';

function formatNumber(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return n.toLocaleString();
}

function formatPercent(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return `${(n * 100).toFixed(1)}%`;
}

function formatMs(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  if (n >= 1000) return `${(n / 1000).toFixed(2)}s`;
  return `${Math.round(n)}ms`;
}

export function MeteringPanel() {
  const { data, isLoading } = useUsageMetrics('30d');

  const totals = data?.totals;
  const successRate =
    totals && totals.totalCalls > 0
      ? 1 - totals.totalErrors / totals.totalCalls
      : null;

  return (
    <Card className="bg-gray-900 ring-gray-800 h-full flex flex-col">
      <Flex justifyContent="between" alignItems="center" className="mb-4">
        <Title className="text-gray-100">Platform Usage · last 30d</Title>
        <Link
          to="/monitoring"
          className="text-cyan-400 text-xs font-medium hover:text-cyan-300 hover:underline"
        >
          View detailed monitoring →
        </Link>
      </Flex>

      {isLoading && !data ? (
        <div className="flex-1 flex items-center justify-center">
          <Text className="text-gray-500">Loading...</Text>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          <Kpi label="Requests" value={formatNumber(totals?.totalRequests)} hint={`${formatNumber(totals?.totalHarmful)} harmful`} />
          <Kpi label="Tokens" value={formatNumber(totals?.totalTokens)} hint={`${formatNumber(totals?.totalCalls)} calls`} />
          <Kpi label="Avg latency" value={formatMs(totals?.avgLatencyMs)} hint={`p95 ${formatMs(totals?.p95Ms)}`} />
          <Kpi label="Success rate" value={formatPercent(successRate)} hint={`${formatNumber(totals?.totalErrors)} errors`} />
        </div>
      )}
    </Card>
  );
}

function Kpi({ label, value, hint }: { label: string; value: string; hint: string }) {
  return (
    <div className="rounded-md ring-1 ring-gray-800 p-3">
      <Text className="text-gray-400 text-xs">{label}</Text>
      <p className="text-xl font-semibold text-gray-100 mt-1">{value}</p>
      <Text className="text-gray-500 text-xs mt-1">{hint}</Text>
    </div>
  );
}
